import { render, staticRenderFns } from "./componentImport.vue?vue&type=template&id=2a6ebb63"
import script from "./componentImport.vue?vue&type=script&lang=js"
export * from "./componentImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports